/* kult-method-attr.js — schreibt die im Browser gewählte Zubereitung (localStorage 'kult:method') als Warenkorb-Attribut
   kult_method, damit die Kult-Events-App bei „Ganze Bohne“-Bestellungen die Zubereitungsart trotzdem kennt
   (docs/requirements/2026-10-03-zubereitung-segmentierung-spec.md). Läuft für alle Besucher, nur bei gefülltem Warenkorb,
   nur wenn der Wert abweicht; keine Cookies, kein Tracking. Eingebunden über snippets/kult-customer-prefs.liquid. */
(function () {
  'use strict';
  if (window.__kultMethodAttr) return;
  window.__kultMethodAttr = true;
  var busy = false;

  function sync() {
    if (busy) return;
    var method = '';
    try { method = localStorage.getItem('kult:method') || ''; } catch (e) { return; }
    if (!method) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.item_count) return null;
        if (cart.attributes && cart.attributes.kult_method === method) return null;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { kult_method: method } })
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  ['kult:cart:add', 'kult:cart:updated', 'kult:method:changed'].forEach(function (name) {
    document.addEventListener(name, function () { setTimeout(sync, 400); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
